import { render, staticRenderFns } from "./RegularForms.vue?vue&type=template&id=d0a1a162&scoped=true&"
import script from "./RegularForms.vue?vue&type=script&lang=js&"
export * from "./RegularForms.vue?vue&type=script&lang=js&"
import style0 from "./RegularForms.vue?vue&type=style&index=0&id=d0a1a162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a1a162",
  null
  
)

export default component.exports